import React, { useContext } from "react"
import { Animated, Easing, Modal, Text, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
import { textStyles } from "../style"
import Typewriter from "./typewriter"
import AppIcon from "../assets/images/logo/Logo.png"
import useScreenSize from "./screen-size"
import { MAX_CONTENT_WIDTH } from "../config"

type Props = {
  loading: boolean
  text?: string
  ellipsis?: boolean
}

const FullScreenLoading:React.FC<Props> = ({loading, text, ellipsis}:Props) => {
  const theme = useContext(ThemeContext).theme
  const { bgMain, textMain } = theme.colors
  const MAX_LOGO_HEIGHT = 80
  const MIN_LOGO_HEIGHT = 40
  
  const { width } = useScreenSize()

  const spinValue = new Animated.Value(0)
  const logoHeightValue = new Animated.Value(Math.min(width, MAX_CONTENT_WIDTH))

  Animated.loop(
    Animated.timing(
      spinValue,
      {
        toValue: 1,
        duration: 1500,
        easing: Easing.back(2),
        useNativeDriver: false,
      }
    )
  ).start()

  const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '360deg']
  })

  const logoHeight = logoHeightValue.interpolate({
    inputRange: [300, MAX_CONTENT_WIDTH],
    outputRange: [MIN_LOGO_HEIGHT, MAX_LOGO_HEIGHT],
  })

  return (
    <Modal animationType={"none"} visible={loading}>
      <View style={{backgroundColor: bgMain, flex: 1, justifyContent: "center", alignItems: "center"}}>
        <Animated.Image 
          source={AppIcon}
          style={{height: logoHeight, aspectRatio: 1, transform: [{rotate: spin}]}}
        />
        <Text style={[textStyles.body, {color: textMain, marginTop: 10}]}>
        {
          // If text is provided, display it. Otherwise, display a space to prevent logo jumping
          text ? <>
            {text} { ellipsis && <Typewriter text="..." restartDelay={500} style={textStyles.body}/>}
          </> : ' '
        }
        </Text>
      </View>
    </Modal>
  )
}

export default FullScreenLoading